module.exports = __webpack_public_path__ + "static/img/img2d.3c28e54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/img2d.png
// module id = kCeI
// module chunks = 1